export default __webpack_public_path__ + "static/media/cr.fba3ebb5.svg";